export enum MaliciousResourceItemType {
  Ip = 1,
  Domain = 2,
  Hostname = 3,
  Url = 4,
  Link = 5,
}

export enum MaliciousResourceThreatType {
  Malware = 1,
  Phishing = 2,
}

export enum ScanMainNameType {
  Basic = 1,
  Standard = 2,
  Full = 3,
}

export enum ScanFrequencyType {
  "One Time" = 0,
  "Daily" = 1,
  "Weekly" = 2,
  "Monthly" = 3,
}

export enum ScanIdType { //! unused
  '67cc33760d6fca3c611c829d' = 1, // DnsIntegrityCheck
  '67cc33760d6fca3c611c829f' = 3, // VulnerabilityDetection
  '67cc33760d6fca3c611c82a0' = 4, // SubdomainVulnerabilityDetection
  '67cc33760d6fca3c611c82a1' = 5, // SecurityHeadersValidator
  '67cc33760d6fca3c611c82a2' = 6, // SecuritySubdomainHeadersValidator
  '67cc33760d6fca3c611c82a3' = 7, // PortScanner
  '67cc33760d6fca3c611c82a4' = 8, // SubdomainPortScanner
  '67cc33760d6fca3c611c82a5' = 9, // SslTlsConfigurationAudit
  '67cc33760d6fca3c611c82a6' = 10, // SubdomainSslTlsConfigurationAudit
  '67cc33760d6fca3c611c82a7' = 11, // MaliciousContentDetection
  '67cc33760d6fca3c611c82a8' = 12, // SubdomainMaliciousContentDetection
  '67cc33760d6fca3c611c82a9' = 13, // HiddenPathsFileDetection
  '67cc33760d6fca3c611c82aa' = 14, // SubdomainHiddenPathsFileDetection
  '67cc33760d6fca3c611c82ab' = 15, // SecretsAndSensitiveDataFinder
  '67cc33760d6fca3c611c82ac' = 16, // SubdomainSecretsAndSensitiveDataFinder
  '67cc4689dc74639bcae3bfb0' = 17, // ResourceTakeoverDefense
}

export enum SensitiveResourceItemType {
  File = 1,
  Path = 2,
}

export enum ScanStatusType {
  NotSelected = 1, // No scans have been performed for this domain yet.
  Scanning = 2, // Currently scanning...
  Finished = 3, // No incidents  (or the rows)
  Independent = 4, // behaves as 3
}

export enum FindingStatusType {
  Open = 1,
  InProgress = 2,
  Ignore = 3,
  Resolved = 4,
  FalsePositive = 5,
}

export enum LoginStatus {
  Success = 0,
  Failed = 1,
  RequiresTwoFactor = 2,
  EmailNotConfirmed = 3,
  UserInactive = 4,
}

export enum AlertType {
  Added = 1,
  Removed = 2,
}

export enum RecordType {
  DMARC = 1,
  SPF = 2,
  'MTA-STS' = 3,
  'TLS-RPT' = 4,
  BIMI = 5,
  DNSSEC = 6,
  AXFR = 7,
  NS = 8,
  MX = 9,
}

export enum SignalRProtocolType { // type of signalr protocol
  Invocation = 1, // method call
  StreamItem = 2, // stream item
  Completion = 3, // result/ error response
  StreamInvocation = 4, // stream invocation
  CancelInvocation = 5, // cancel invocation
  Ping = 6, // ping
  Close = 7, // close
}

export enum SecurityActionPlanType {
  Dns = 1,
  Header = 2,
  Cve = 3,
  Port = 4,
  Ssl = 5
}